var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26688(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26688",
    "data-name": "Group 26688",
    transform: "translate(-240 -788)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(240 788)",
    fill: "#1e8d3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23248",
    "data-name": "Path 23248",
    d: "M262.165,77.247v8.207H224.646V77.247a3.607,3.607,0,0,1,3.517-3.517h5.862V70.212a3.607,3.607,0,0,1,3.517-3.517h11.725a3.607,3.607,0,0,1,3.517,3.517V73.73h5.862a3.606,3.606,0,0,1,3.517,3.517M248.1,87.8h14.07V98.352a3.607,3.607,0,0,1-3.517,3.517H228.163a3.607,3.607,0,0,1-3.517-3.517V87.8h14.07v3.517a1.177,1.177,0,0,0,1.172,1.172h7.035a1.171,1.171,0,0,0,1.172-1.172Zm1.172-17.587H237.543V73.73h11.725Z",
    transform: "translate(32.354 739.305)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26688);
export default __webpack_public_path__ + "static/media/Group 26688.dc4347a80b45281f72f929e1bf844b69.svg";
export { ForwardRef as ReactComponent };